// removed by extract-text-webpack-plugin
module.exports = {"Content":"PasswordRecovery-module__Content__1kAg_","MessageWrapper":"PasswordRecovery-module__MessageWrapper__2MGP5","FooterWrapper":"PasswordRecovery-module__FooterWrapper__2U8Dc","Footer":"PasswordRecovery-module__Footer__33ZyA","Focused":"PasswordRecovery-module__Focused__UzbOm","SpinnerWrapper":"PasswordRecovery-module__SpinnerWrapper__Hbsa8","ModalText":"PasswordRecovery-module__ModalText__33Dv9","ButtonWrapper":"PasswordRecovery-module__ButtonWrapper__DO5yG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/PasswordRecovery/PasswordRecovery.module.css
// module id = 1707
// module chunks = 31